module.exports = __webpack_public_path__ + "static/media/product-bg2.082e62b7.png";